import { createSlice } from '@reduxjs/toolkit'
import { IDLE } from '../../constants/constants'
import {
  loadConfig,
  fetchDataForItems_aggregated,
  fetchPrices_aggregated,
  addToCart_aggregated,
  submitForm_aggregated,
} from './thunks'
import { getBaseUrls } from '../../helpers/getBaseUrls'
import { type APIConfig } from './apiTypes'

const handleStatus = (state: RequestsState, action: any): void => {
  const thunk = action.type.slice(0, action.type.lastIndexOf('/')).replace('thunks/', '')
  const { requestStatus } = action.meta

  if (thunk === 'fetchPrices_aggregated' && requestStatus === 'pending') {
    state._latestPendingRequestId_fetchPrices_aggregated = action.meta.requestId
  }

  if (
    thunk === 'fetchPrices_aggregated' &&
    requestStatus !== 'pending' &&
    state._latestPendingRequestId_fetchPrices_aggregated !== action.meta.requestId
  ) {
    if (import.meta.env.VITE_SCENSUM_ENV !== 'production') {
      console.log(
        `mok-context-spa in dev/test env: fetchPrices_aggregated was ${requestStatus} for deprecated DM 'configuration-update' event -- requestStatus_fetchPrices_aggregated is not updated in Redux store.`
      )
    }

    return
  }

  // @ts-expect-error TODO: fix!
  state.requestStatus[`requestStatus_${thunk}`] = requestStatus

  if (thunk === 'fetchPrices_aggregated' && requestStatus === 'fulfilled') {
    state.hasBeenFulfilled_fetchPrices_aggregated = true
  }
}

interface RequestsState {
  apiConfigs: APIConfig
  requestStatus: {
    requestStatus_loadConfig: string
    requestStatus_fetchDataForItems_aggregated: string
    requestStatus_fetchPrices_aggregated: string
    requestStatus_addToCart_aggregated: string
    requestStatus_submitForm_aggregated: string
  }
  hasBeenFulfilled_fetchPrices_aggregated: boolean
  _latestPendingRequestId_fetchPrices_aggregated: string
}

const initialState: RequestsState = {
  apiConfigs: {
    marketCode: '',
    languageCode: '',
    assetsOriginBaseUrl: '',
    configstoreApiBaseUrl: '',
    eventApiBaseUrl: '',
    lfcApiBaseUrl: '',
    scensumBaseUrl: '',
    skbvApiBaseUrl: '',
  },
  requestStatus: {
    requestStatus_loadConfig: IDLE,
    requestStatus_fetchDataForItems_aggregated: IDLE,
    requestStatus_fetchPrices_aggregated: IDLE,
    requestStatus_addToCart_aggregated: IDLE,
    requestStatus_submitForm_aggregated: IDLE,
  },
  hasBeenFulfilled_fetchPrices_aggregated: false,
  _latestPendingRequestId_fetchPrices_aggregated: '',
}

const requestsSlice = createSlice({
  name: 'requests',
  initialState,
  reducers: {
    setApiConfigs(state, action) {
      const { marketCode, languageCode } = action.payload

      const { assetsOriginBaseUrl, configstoreApiBaseUrl, eventApiBaseUrl, lfcApiBaseUrl, scensumBaseUrl, skbvApiBaseUrl } = getBaseUrls()

      state.apiConfigs = {
        marketCode,
        languageCode,
        assetsOriginBaseUrl,
        configstoreApiBaseUrl,
        eventApiBaseUrl,
        lfcApiBaseUrl,
        scensumBaseUrl,
        skbvApiBaseUrl,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadConfig.pending, handleStatus)
      .addCase(loadConfig.fulfilled, handleStatus)
      .addCase(loadConfig.rejected, handleStatus)
      .addCase(fetchDataForItems_aggregated.pending, handleStatus)
      .addCase(fetchDataForItems_aggregated.fulfilled, handleStatus)
      .addCase(fetchDataForItems_aggregated.rejected, handleStatus)
      .addCase(fetchPrices_aggregated.pending, handleStatus)
      .addCase(fetchPrices_aggregated.fulfilled, handleStatus)
      .addCase(fetchPrices_aggregated.rejected, handleStatus)
      .addCase(addToCart_aggregated.pending, handleStatus)
      .addCase(addToCart_aggregated.fulfilled, handleStatus)
      .addCase(addToCart_aggregated.rejected, handleStatus)
      .addCase(submitForm_aggregated.pending, handleStatus)
      .addCase(submitForm_aggregated.fulfilled, handleStatus)
      .addCase(submitForm_aggregated.rejected, handleStatus)
  },
})

export const { setApiConfigs } = requestsSlice.actions

export default requestsSlice.reducer
